import { render } from "./ModalDetalhesOrcamento.vue?vue&type=template&id=5418104a&scoped=true"
import script from "./ModalDetalhesOrcamento.vue?vue&type=script&lang=js"
export * from "./ModalDetalhesOrcamento.vue?vue&type=script&lang=js"

import "./ModalDetalhesOrcamento.vue?vue&type=style&index=0&id=5418104a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5418104a"]])

export default __exports__